import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
import * as dictionary from "../utils/dictionary";
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'YView',
  props: {
    col: {
      type: Array,
      default: []
    } //表示分成几列,如['180px','auto']表示左侧180，右侧铺满
  },

  setup(__props) {
    const props = __props;
    const col = ref(props.col);
    function sty(item, i) {
      const len = props.col.length;
      if (i !== len - 1) {
        return {
          float: "left",
          width: item,
          height: "100%",
          resize: "none",
          overflow: "auto"
        };
      }
      if (item == "auto") {
        return {
          "margin-left": props.col[0],
          height: "100%",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column"
        };
      }
      return {};
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([_ctx.css.vw, {
          [_ctx.css.no_col]: !col.value || !col.value.length
        }])
      }, [col.value && col.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(col.value, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          style: _normalizeStyle(sty(item, i))
        }, [_renderSlot(_ctx.$slots, 'col' + i, {
          dic: dictionary
        })], 4);
      }), 128)) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["flex direction_column grow_1", [_ctx.css.view_cont, {
          [_ctx.css.view_cont_width_bottom]: _ctx.$slots.bottom
        }]])
      }, [_ctx.$slots.top ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.css.view_cont_top)
      }, [_renderSlot(_ctx.$slots, "top", {
        dic: dictionary
      })], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass([[_ctx.css.view_cont_default, {
          [_ctx.css.view_cont_default_padding_bottom]: _ctx.$slots.bottom
        }], "flex direction_column grow_1"])
      }, [_ctx.$slots.title ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.css.title)
      }, [_renderSlot(_ctx.$slots, "title")], 2)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default", {
        dic: dictionary
      })], 2), _ctx.$slots.bottom ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(_ctx.css.bottom)
      }, [_renderSlot(_ctx.$slots, "bottom")], 2)) : _createCommentVNode("", true)], 2))], 2);
    };
  }
});